import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';

import { publicEnv } from '@/lib/env';

const GEAR_ILLUSTRATION_BASE = `${publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL}/global/player-dashboard/gear`;

const illustration = (file: string, width: number, height: number) =>
  getCDNURL(`${GEAR_ILLUSTRATION_BASE}/${file}`, width, height);

export const GEAR_EMPTY_STATE_ALL_ILLUSTRATION = illustration('Mascot_All_Gear.svg', 200, 142);

// Shared with the dashboard ranking widgets' empty states, which reuse these mascots by design.
export const GEAR_EMPTY_STATE_HATS_ILLUSTRATION = illustration('Mascot_Hats.svg', 220, 156);
export const GEAR_EMPTY_STATE_TRAINING_ILLUSTRATION = illustration(
  'Mascot_Jump_Paddle.svg',
  220,
  156
);

const GEAR_EMPTY_STATE_ILLUSTRATION_BY_CATEGORY: Record<string, string> = {
  all: GEAR_EMPTY_STATE_ALL_ILLUSTRATION,
  paddles: illustration('Double_Paddles_Green_Blue.svg', 178, 166),
  balls: illustration('Coloured_Balls_Set.svg', 100, 71),
  shoes: illustration('Mascot_Shoes.svg', 180, 127),
  bags: illustration('Mascot_Bag.svg', 200, 142),
  grips: illustration('Red_Paddle_Grip.svg', 178, 166),
  gloves: illustration('Gloves_Hold_Paddle.svg', 150, 106),
  socks: illustration('Mascot_Socks.svg', 240, 170),
  hats: GEAR_EMPTY_STATE_HATS_ILLUSTRATION,
  glasses: illustration('Mascot_Glasses.svg', 240, 170),
  'paddle covers': illustration('Mascot_Sit_Paddle.svg', 220, 156),
  training: GEAR_EMPTY_STATE_TRAINING_ILLUSTRATION,
  'support and recovery': illustration('Mascot_Support_Recovery.svg', 200, 142),
  nets: illustration('Mascot_Nets.svg', 220, 156),
  'ball machines': illustration('Mascot_Ball_Machine.svg', 220, 156),
};

const normalizeCategoryName = (name: string) =>
  name
    .trim()
    .toLowerCase()
    .replace(/\s*&\s*/g, ' and ')
    .replace(/\s+/g, ' ');

export const getGearEmptyStateIllustration = (categoryName?: string) =>
  (categoryName &&
    GEAR_EMPTY_STATE_ILLUSTRATION_BY_CATEGORY[normalizeCategoryName(categoryName)]) ||
  GEAR_EMPTY_STATE_ALL_ILLUSTRATION;
